module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IT-562cc8603af3c39ed0a1581d97e91a3c.png";